import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import ReactDOM from 'react-dom/client';
import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import routes from './routes';
import './include/bootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <div className="desktopTemplate od-bg-sidePanels">
      <div className="desktopMaxWidthTemplate">
        {routes}
      </div>
    </div>
  </Provider>
);
